import React, { useState } from "react"
import { Link } from 'gatsby'
import keygen from "keygenerator"

import "./css/Points.min.css"
import { points } from "~content/blog/blogPosts"

const POSTS_PER_PAGE = 5

const Points = () => {
  const [currentPage, setCurrentPage] = useState(1)

  const totalPages = Math.ceil(points.length / POSTS_PER_PAGE)
  const startIndex = (currentPage - 1) * POSTS_PER_PAGE
  const currentPosts = points.slice(startIndex, startIndex + POSTS_PER_PAGE)

  const handlePageChange = (page) => {
    setCurrentPage(page)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const contents = currentPosts.map(point => {
    const { key, icon, title, to, description, note } = point
    return (
      <Link key={key} className="blog-item_ point" to={to} title={title}>
        <div className="iconArea">
          <img src={icon.default} alt={title} />
        </div>
        <div className="descriptionArea">
          <h5 className="blog-list-title_">{title}</h5>
          {note && <span className="footnote_">{note}</span>}
        </div>
      </Link>
    )
  })

  return (
    <div>
      <div className="blog-listing_ points">
        {contents}
      </div>

      {/* Only show pagination if more than 10 posts */}
      {points.length > POSTS_PER_PAGE && (
        <div className="pagination">

          {/* Prev button */}
          <button
            className="pagination-btn"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            ← Prev
          </button>

          {/* Page number buttons */}
          {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
            <button
              key={page}
              className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          ))}

          {/* Next button */}
          <button
            className="pagination-btn"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next →
          </button>

        </div>
      )}
    </div>
  )
}

export default Points